"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = require("react");
var _excluded = ["defaultValue", "onChange", "required", "symbol"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputCurrency/index.js";
function InputCurrency(_ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
    onChange = _ref.onChange,
    required = _ref.required,
    _ref$symbol = _ref.symbol,
    symbol = _ref$symbol === void 0 ? "₱" : _ref$symbol,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(""),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    displayValue = _useState2[0],
    setDisplayValue = _useState2[1];
  function format(val) {
    if (val === "") return "";
    var _val$toString$replace = val.toString().replace(/,/g, "").split("."),
      _val$toString$replace2 = (0, _slicedToArray2["default"])(_val$toString$replace, 2),
      intPart = _val$toString$replace2[0],
      decPart = _val$toString$replace2[1];
    var formattedInt = intPart ? parseInt(intPart, 10).toLocaleString("en-US") : "";
    return decPart !== undefined ? "".concat(formattedInt, ".").concat(decPart) : formattedInt;
  }
  (0, _react.useEffect)(function () {
    setDisplayValue(format(defaultValue));
  }, [defaultValue]);
  function handleChange(e) {
    var raw = e.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(raw)) return;
    setDisplayValue(format(raw));
    onChange === null || onChange === void 0 ? void 0 : onChange(raw);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "input-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, symbol), /*#__PURE__*/React.createElement("input", Object.assign({
    type: "text",
    className: "form-control",
    value: displayValue,
    onChange: handleChange,
    required: required
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  })));
}
var _default = exports["default"] = InputCurrency;